import { gql } from '@apollo/client';

const Fragments = {
  engineScoringGridItem: gql`
    fragment engineScoringGridItem on EngineScoringGridItem {
      isReadOnly
      engineScoringId
      name
      code
      version
      validFrom
      validTo
      defaultYN
      active
      targetContextId
      docStructureKey
      entityIdentifierForTest
      periodSelectionModeId
      financialIndicatorDimensionCount
      useAllAttributes
      isHistory
      evaluationOrder
      displayOrder
      filterTypeId
      partnerTypeFormula
      partnerTypeId
    }
  `,
  engineScoringGridIntervalItem: gql`
    fragment engineScoringGridIntervalItem on EngineScoringGridIntervalItem {
      engineIntervalId
      engineScoringId
      startsWith
      endsWith
      resultId
    }
  `,
  engineScoringGridRuleItem: gql`
    fragment engineScoringGridRuleItem on EngineScoringGridRuleItem {
      engineRuleId
      number
      name
      expression
      engineScoringId
      targetId
    }
  `,
  engineScoringGridKnockoutCriteriaItem: gql`
    fragment engineScoringGridKnockoutCriteriaItem on EngineScoringGridKnockoutCriteriaItem {
      engineScoringKnockoutCriteriaId
      engineScoringId
      criteriaId
      manualYN
      preScoring
      postScoring
      aplicabilityFormula
      titleFormula
      resultFormula
    }
  `,
  engineScoringGridXExternalSystemItem: gql`
    fragment engineScoringGridXExternalSystemItem on EngineScoringGridXExternalSystemItem {
      engineScoringXExternalSystemId
      engineScoringId
      externalSystemId
      isMandatory
    }
  `,
  engineScoringXAttributeItem: gql`
    fragment engineScoringXAttributeItem on EngineScoringXAttributeItem {
      engineScoringXAttributeId
      engineScoringId
      engineAttributeId
      executionOrder
    }
  `,
  engineScoringXPartnerTypeItem: gql`
    fragment engineScoringXPartnerTypeItem on EngineScoringXPartnerTypeItem {
      id
      engineScoringId
      partnerTypeId
    }
  `,
  engineScoringGridXPartnerBaseTypeItem: gql`
    fragment engineScoringGridXPartnerBaseTypeItem on EngineScoringGridXPartnerBaseTypeItem {
      id
      engineScoringId
      partnerBaseTypeId
    }
  `,
  engineScoringGridClassificationItem: gql`
    fragment engineScoringGridClassificationItem on EngineScoringGridClassificationItem {
      engineScoringClassificationId
      engineScoringClassificationName
      engineScoringId
      orderNo
      visibleYN
      linkedRuleId
      displayPageId
    }
  `,
  engineScoringGridClassificationXEngineAttributeItem: gql`
    fragment engineScoringGridClassificationXEngineAttributeItem on EngineScoringGridClassificationXEngineAttributeItem {
      engineScoringClassificationXEngineAttributeId
      engineScoringClassificationId
      engineAttributeId
      description
      orderNo
    }
  `,
  engineScoringGridClassificationXScoringItem: gql`
    fragment engineScoringGridClassificationXScoringItem on EngineScoringGridClassificationXScoringItem {
      engineScoringClassificationXScoringId
      engineScoringClassificationId
      scoringId
      scoringName
      orderNo
      readOnlyCategory
      isMandatory
    }
  `,
  engineScoringGridClassificationXFinancialIndicatorItem: gql`
    fragment engineScoringGridClassificationXFinancialIndicatorItem on EngineScoringGridClassificationXFinancialIndicatorItem {
      engineScoringClassificationXFinancialId
      engineScoringClassificationId
      financialIndicatorId
      financialIndicatorName
      orderNo
      isMandatory
    }
  `,
  engineAttributeItem: gql`
    fragment engineAttributeItem on EngineAttributeItem {
      engineAttributeId
      orderNo
      attributeName
      description
      expression
      storeYN
      sensitiveInfo
    }
  `,
  scoringGridTestResultItem: gql`
    fragment scoringGridTestResultItem on ScoringGridTestResultItem {
      responseScore
    }
  `,
  scoringGridTestResultAttributeItem: gql`
    fragment scoringGridTestResultAttributeItem on ScoringGridTestResultAttributeItem {
      attributeName
      attributeDescription
      attributeValue
    }
  `
};

export default Fragments;
